import { DropdownMenu, Toolbar } from '@box/blueprint-web';
import type { Editor } from '@tiptap/react';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { DEFAULT_FONT_SIZE, FONT_SIZES } from '../../../constants';
import messages from '../../../messages';
import { getFontSizeNumber } from '../utils/font-size';

type FontSizeDropdownProps = {
  editor: Editor;
  containerRef: { current: HTMLElement | null | undefined };
};

export const FontSizeDropdown = ({
  editor,
  containerRef,
}: FontSizeDropdownProps) => {
  const [isFontSizeOpen, setIsFontSizeOpen] = React.useState(false);
  const intl = useIntl();

  const { fontSize: activeFontSize = '' } =
    editor.getAttributes('textStyle') || {};
  const activeFontSizeNum =
    getFontSizeNumber(activeFontSize) || DEFAULT_FONT_SIZE;

  return (
    <DropdownMenu.Root
      modal={false}
      onOpenChange={setIsFontSizeOpen}
      open={isFontSizeOpen}
    >
      <DropdownMenu.Trigger>
        <Toolbar.DropdownTriggerButton
          aria-label={intl.formatMessage(
            messages.editorToolbarFontSizeAriaLabel,
          )}
          className="fontSizeButtonLabel"
          selected={false}
        >
          <FormattedMessage
            {...messages.fontSizeName}
            values={{ num: activeFontSizeNum }}
          />
          <Toolbar.DropdownIndicator
            direction={isFontSizeOpen ? 'up' : 'down'}
          />
        </Toolbar.DropdownTriggerButton>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        align="start"
        container={containerRef.current}
        loop
        onCloseAutoFocus={() => editor.commands.focus()}
      >
        {FONT_SIZES.map(sizeNumber => {
          const fontSize = `${sizeNumber}pt`;
          const isFontSizeActive = activeFontSizeNum === sizeNumber;
          return (
            <DropdownMenu.CheckboxItem
              key={`fontsize-${sizeNumber}`}
              checked={isFontSizeActive}
              onCheckedChange={() =>
                editor.chain().focus().setFontSize(fontSize).run()
              }
            >
              <FormattedMessage
                {...messages.fontSizeName}
                values={{ num: sizeNumber }}
              />
            </DropdownMenu.CheckboxItem>
          );
        })}
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
